let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aEr6V")).then(() => parcelRequire('5d39M'));